import { ASSESSMENTS } from './assessments';
import { TRAININGS } from './trainings';

export type PageKind = 'assessment' | 'program';

export interface PageDescriptor {
  kind: PageKind;
  id: string;
  slug: string;
  /** Site-relative path with trailing slash, e.g. /assessments/survivor/ */
  path: string;
  title: string;
  description: string;
}

export const KIND_DIR: Record<PageKind, string> = { assessment: 'assessments', program: 'programs' };

export function pagePath(kind: PageKind, slug: string): string {
  return `/${KIND_DIR[kind]}/${slug}/`;
}

/** Every static page the build generates. Add an item to assessments.ts or trainings.ts and it appears here. */
export const PAGES: PageDescriptor[] = [
  ...ASSESSMENTS.map(a => ({ kind: 'assessment' as const, id: a.id, slug: a.slug, path: pagePath('assessment', a.slug), title: a.title, description: a.metaDescription })),
  ...TRAININGS.map(t => ({ kind: 'program' as const, id: t.id, slug: t.slug, path: pagePath('program', t.slug), title: t.title, description: t.metaDescription })),
];

export function pageFor(kind: PageKind, id: string): PageDescriptor | undefined {
  return PAGES.find(p => p.kind === kind && p.id === id);
}
